import React, { useState } from "react";
import { Accordion, Card, Image, Form, Row, Col } from "react-bootstrap";
import { ObjectListItem } from './components';

const NestedList = props => {
  const { objectLists, ...rest } = props;

  return (
    <>
      {objectLists.reduce(
        (items, objectList, objIndex) => reduceChildObjects({ items, objectList, objIndex, ...rest }),
        []
      )}
    </>
  );
};

const reduceChildObjects = props => {
  const { items, objectList, depth, formState, setFormState, key, setObjectId, objIndex } = props;
  
  if (objectList.children) {
    items.push(
      <ObjectListItem
        depth={depth}
        objIndex={objIndex}
        key={objectList.id}
        label={objectList.label}
        open={false}
        title={objectList.name}
        objectType={objectList?.object_type?.opt_display}
        setFormState={setFormState}
        formState={formState}
        objectListItem={objectList}
        setObjectId={setObjectId}
      >
        <NestedList
          depth={depth + 1}
          parentDepth={depth}
          objectLists={objectList.children}
          setFormState={setFormState}
          formState={formState}
          setObjectId={setObjectId}
        />
      </ObjectListItem>
    );
  } else {
    items.push(
      <ObjectListItem
        depth={depth}
        key={objectList.id}
        label={objectList.label}
        title={objectList.name}
        objectType={objectList?.object_type?.opt_display}
        setFormState={setFormState}
        formState={formState}
        objectListItem={objectList}
        setObjectId={setObjectId}
      />
    );
  }

  return items;
};

const NestedObjects = props => {
  const { objectLists, formState, setFormState, ...rest } = props;

  const [objectId, setObjectId] = useState('');

  //const [activeKey, setActiveKey] = useState(null);

  //const [activeNestedAccordion, setActiveNestedAccordion] = useState({
  const [activeKey, setActiveKey] = useState({
    0: null,
    1: null,
    2: null,
    3: null,
    4: null,
  });

  const toggleAccordion = (key, depth) => {
    //setActiveKey(activeKey === key ? null : key);

    setActiveKey((activeKey) => ({
      [depth]: activeKey[depth] === key ? null : key
    }));
    //false are childs after depth (have to do this nestedly)
  };

  return (
    <NestedList
      depth={0}
      objectLists={objectLists}
      setFormState={setFormState}
      formState={formState}
      setObjectId={setObjectId}
      toggleAccordion={toggleAccordion}
    />
  );
};

export default NestedObjects;
